import { Box, Button, Card, CardActionArea, CardContent, Grid, Stack, Theme } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { DEFAULT_LIST_SIZE_PER_PAGE, selectBtn, yesSelectThisLocationBtn } from '../../../Constants/Constants';
import { ShopsInfo } from '../../../model/shops.response';
import { PaginationData } from '../../../types/type';
import { ChevronRightIcon } from '../../shared/Svg-icons/App-Icons';
import Pages from '../Pagination/Pages';
import Address from '../ShopAddress/ShopAddress';
import ShopHoursAndDistance from '../ShopHoursDistance/ShopHoursAndDistance';

interface Props {
  shops: ShopsInfo[] | undefined;
  shopCardSelectionHandler: (shop: ShopsInfo) => void;
  paginationData: PaginationData | null | undefined;
  pageSelectionChangeHandler: (pageNumber: number) => void;
  locationSelection: any;
  confirm: boolean;
  setConfirm: any;
}

const ShopInfoCard = (props: Props) => {
  const theme: Theme = useTheme();

  const shopSelectionStateCheck = () => {
    if (props.shops) {
      return props.shops.some((item) => item.isActive);
    }
    return false; // Always return a value
  };

  const handleShopCardOnClick = (shop: ShopsInfo) => {
    props.shopCardSelectionHandler(shop);
  };

  const makeSelection = (shop: any) => {
    props.locationSelection(shop);
  };

  const cardStyling = {
    padding: '0px',
    '&:hover': {
      //backgroundColor: theme.custom.colors.listItemHoverColor,
    },
  };

  const handleClick = () => {
    if (props.locationSelection && props.shops?.length === 1) {
      !props.confirm ? props.setConfirm(true) : makeSelection(props.shops[0]);
    }
  };

  return (
    <Box
      sx={{
        maxHeight: '54vh',
        overflowY: 'scroll',
        overflowX: 'hidden',
        width: '100%',
        paddingRight: '2rem',
        [theme.breakpoints.down('md')]: {
          marginBottom: '2rem',
          paddingBottom: '2rem',
        },
        [theme.breakpoints.up('md')]: {
          marginBottom: '1rem',
          paddingBottom: '1rem',
        },
      }}
      data-testid="shopsList"
    >
      {props.shops &&
        props.shops?.map((shop, index) => (
          <React.Fragment key={shop.id}>
            <Box
              sx={{
                boxShadow: '0px 4px 12px 1px rgb(128, 128, 128, 0.5)',
                m: '1rem',
                width: '100%',
                display: 'grid',
              }}
            >
              <Card
                variant="outlined"
                sx={cardStyling}
                id={`${'automation_card_' + shop.id}`}
                onClick={() => {
                  handleShopCardOnClick(shop);
                }}
              >
                <Stack direction="column">
                  <CardActionArea data-testid={`shopsListItem-${index}`} disableRipple={shop.isActive ? true : false}>
                    <Grid container sx={{ padding: '15px' }}>
                      <Grid container item xs={10}>
                        <CardContent
                          sx={{
                            p: '0px',
                            '&:last-child': {
                              paddingBottom: 0,
                            },
                          }}
                        >
                          <Address buttonEnabled={props.shops?.length === 1} shop={shop} confirm={props.confirm} />
                        </CardContent>
                      </Grid>

                      {!shop.isActive && (
                        <Grid container item xs={2} alignItems="center" justifyContent="space-around">
                          <ChevronRightIcon sx={{ color: theme.custom.colors.secondaryColor }} />
                        </Grid>
                      )}
                    </Grid>
                    {shop.isActive && props.shops?.length === 1 && (
                      <React.Fragment>
                        <Grid item>
                          <ShopHoursAndDistance shop={shop} />
                        </Grid>
                        <Grid item>
                          <Box sx={{ p: '1rem' }}>
                            <Button
                              onClick={handleClick}
                              sx={{
                                ...theme.custom.styles.ctaNextButton,
                                width: '100%',
                                '&.MuiButtonBase-root:hover': {
                                  bgcolor: theme.custom.colors.primaryButtonHoverColor,
                                },
                                marginLeft: '0px',
                                minHeight: 'auto',
                              }}
                              // display="block" is not a valid prop for MUI Button, so just use sx
                            >
                              {!props.confirm ? selectBtn : yesSelectThisLocationBtn}
                            </Button>
                          </Box>
                        </Grid>
                      </React.Fragment>
                    )}
                  </CardActionArea>
                </Stack>
              </Card>
            </Box>
          </React.Fragment>
        ))}
      <Box sx={{ margin: '1rem 0rem 1rem 1rem', width: '100%' }}>
        {!shopSelectionStateCheck() &&
          props.paginationData &&
          props.paginationData?.totalResultCount > DEFAULT_LIST_SIZE_PER_PAGE && (
            <Pages
              paginationData={props.paginationData}
              pageSelectionChangeHandler={props.pageSelectionChangeHandler}
            />
          )}
      </Box>
    </Box>
  );
};

export default ShopInfoCard;
